var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6033 10.2296C19.6033 9.54987 19.5482 8.86643 19.4306 8.19768H9.99829V12.0485H15.3997C15.1756 13.2905 14.4554 14.3891 13.4008 15.0873V17.5859H16.6233C18.5156 15.8442 19.6033 13.2721 19.6033 10.2296Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99826 20C12.6953 20 14.9698 19.1145 16.627 17.5859L13.4045 15.0873C12.5079 15.6972 11.3505 16.0426 10.0019 16.0426C7.39308 16.0426 5.18106 14.2826 4.38738 11.9162H1.06201V14.492C2.7596 17.8688 6.21726 20 9.99826 20Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.38423 11.9162C3.96534 10.6742 3.96534 9.32936 4.38423 8.0874V5.51161H1.06253C-0.355805 8.33726 -0.355805 11.6663 1.06253 14.492L4.38423 11.9162Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99826 3.95737C11.4239 3.93532 12.8019 4.47179 13.8344 5.45654L16.6894 2.6015C14.8816 0.903904 12.4822 -0.0294045 9.99826 -8.94256e-06C6.21726 -8.94256e-06 2.75961 2.13117 1.06201 5.51166L4.38371 8.08744C5.17372 5.71743 7.38941 3.95737 9.99826 3.95737Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.6032,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.01b3a44a8b2cfd973c423dcbbe935550.svg";
export { ForwardRef as ReactComponent };